module.exports = __webpack_public_path__ + "img/_w_.c886b3f6.svg";